import { useRef } from 'react';
import { MdLink } from 'react-icons/md';
import { useLocation } from 'react-router';
import { Button, Icon, Modal, ModalFooter } from '@nbirl/nbi-common-ui-libs';

import { ShareLink } from '../../../../shared/components';

export type ShareFolderModalProps = {
  onDismiss: () => void;
};

export const ShareFolderModal = ({ onDismiss }: ShareFolderModalProps) => {
  const location = useLocation();
  const copyLinkButtonRef = useRef<HTMLButtonElement>(null);

  const link = `${window.location.origin}${location.pathname}`;

  return (
    <Modal
      heading="Get folder link"
      headingIcon={<Icon icon={<MdLink />} />}
      isOpen={true}
      initialFocusRef={copyLinkButtonRef}
      onDismiss={onDismiss}
    >
      <ShareLink link={link} ref={copyLinkButtonRef} />

      <ModalFooter>
        <Button onClick={onDismiss}>Done</Button>
      </ModalFooter>
    </Modal>
  );
};
